import React, {FC, PropsWithChildren} from 'react';
import {observer} from 'mobx-react-lite';
import {Container, I18NText, Icon, useIcons} from '@yosmanyga/rich-ui';

export const MapHelp = observer(
    ({
        templates,
    }: {
        templates: {
            layout: FC<PropsWithChildren>;
        };
    }) => {
        const icons = useIcons();

        return (
            <templates.layout>
                <Container
                    flow="row wrap"
                    align={{
                        cross: 'center',
                    }}
                >
                    <I18NText
                        values={{
                            icon: (
                                <Icon
                                    component={icons.states.collapsed}
                                    align={{
                                        vertical: 'middle',
                                    }}
                                    margin={{
                                        left: 0.5,
                                        right: 0.5,
                                    }}
                                />
                            ),
                        }}
                    >
                        Map Help Line 1
                    </I18NText>
                </Container>

                <Container
                    flow="row wrap"
                    align={{
                        cross: 'center',
                    }}
                >
                    <I18NText
                        values={{
                            icons: (
                                <>
                                    <Icon
                                        component={icons.states.unchecked}
                                        align={{
                                            vertical: 'middle',
                                        }}
                                        margin={{
                                            left: 0.5,
                                        }}
                                    />
                                    <Icon
                                        component={icons.objects.help}
                                        align={{
                                            vertical: 'middle',
                                        }}
                                    />
                                    <Icon
                                        component={icons.objects.pin}
                                        align={{
                                            vertical: 'middle',
                                        }}
                                        margin={{
                                            right: 0.5,
                                        }}
                                    />
                                </>
                            ),
                        }}
                        margin={{
                            top: 4,
                        }}
                    >
                        Map Help Line 2
                    </I18NText>
                </Container>

                <Container
                    flow="row wrap"
                    align={{
                        cross: 'center',
                    }}
                >
                    <I18NText
                        values={{
                            icon: (
                                <Icon
                                    component={icons.objects.route}
                                    align={{
                                        vertical: 'middle',
                                    }}
                                    margin={{
                                        left: 0.5,
                                        right: 0.5,
                                    }}
                                />
                            ),
                        }}
                        margin={{
                            top: 4,
                        }}
                    >
                        Map Help Line 3
                    </I18NText>
                </Container>

                <Container
                    flow="row wrap"
                    align={{
                        cross: 'center',
                    }}
                >
                    <I18NText
                        values={{
                            icon: (
                                <Icon
                                    component={icons.objects.list}
                                    align={{
                                        vertical: 'middle',
                                    }}
                                    margin={{
                                        left: 0.5,
                                        right: 0.5,
                                    }}
                                />
                            ),
                        }}
                        margin={{
                            top: 4,
                        }}
                    >
                        Map Help Line 4
                    </I18NText>
                </Container>
            </templates.layout>
        );
    }
);
